module.exports = __webpack_public_path__ + "static/assets/3e007720150c4b527442139f4d684eb2.svg";